var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FAIcon", {
    attrs: {
      icon: _vm.faIcon,
      size: _vm.size,
      spin: _vm.spin,
      pulse: _vm.pulse
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }